<script>
export default {
  name: 'MenuItem',
  functional: true,
  props: {
    icon: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    }
  },
  render(h, context) {
    const { icon, title } = context.props;
    const vnodes = [];

    if (icon) {
      const iconNode = icon.includes('el-icon')
        ? <i class={[icon, 'sub-el-icon']} />
        : <svg-icon icon-class={icon} class-name='sidebar-svg-icon' />;
      vnodes.push(<span class='menu-icon-frame'>{iconNode}</span>);
    }

    if (title) {
      vnodes.push(<span slot='title' class='menu-title-text'>{(title)}</span>);
    }
    return vnodes;
  }
};
</script>

<style scoped>
.menu-icon-frame {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: none;
}

.sub-el-icon {
  color: currentColor;
  width: 1em;
  height: 1em;
}
</style>
